import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RegisterPage } from './register';
import { RestProvider } from '../../providers/rest/rest';

@NgModule({
  declarations: [
    RegisterPage,
  ],
  imports: [
    IonicPageModule.forChild(RegisterPage),
  ],
  providers: [
    RestProvider,
  ]
})
export class RegisterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/register/register.module.ts